import React, { useEffect } from "react";

import pdtimg1 from "../../assets/pdtimg1.png";
import pdtimg2 from "../../assets/pdtimg2.png";
import pdtimg3 from "../../assets/pdtimg3.png";
import profmak1 from "../../assets/profmak1.png";
import profmak2 from "../../assets/profmak2.png";
import profmak3 from "../../assets/profmak3.png";
import "./Home.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Contact from "../Contact/Contact";
import About from "./About/About";

const pdtimg1Style = {
  background: `url(${pdtimg1})`,
  backgroundPosition: "center center",
  objectFit: `cover`,
};
const pdtimg2Style = {
  background: `url(${pdtimg2})`,
  backgroundPosition: "center center",
  objectFit: `cover`,
};
const pdtimg3Style = {
  background: `url(${pdtimg3})`,
  backgroundPosition: "center center",
  objectFit: `cover`,
};

export default function Home() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div className="home-page" id="home">
      {/* About us */}
      <About />
      {/* Products and Services  */}
      <div className="product">
        <div>
          <p className="pdthead">Products and Services</p>
        </div>
        <div className="pdtsec">
          <div className="pdtbox1">
            <div className="pdtinbox1">
              <p className="pdthead1">Our Business </p>
              <p className="pdtcnt1">
                To delight our customers by offering fabulous support on time.
                To provide the right technical and commercial solutions to our
                customers..
              </p>
            </div>
            <div data-aos="fade-right" className="imgpdt1">
              <div className="pdt-img1">
                <div className="pdtImg1" style={pdtimg1Style}></div>
              </div>
            </div>
          </div>
          <div className="pdtbox1">
            <div data-aos="fade-left" className="imgpdt1">
              <div className="pdt-img1">
                <div className="pdtImg1" style={pdtimg2Style}></div>
              </div>
            </div>
            <div className="pdtinbox1">
              <p className="pdthead1">Our Vision</p>
              <p className="pdtcnt1">
                To manifest our great positive attitude towards our commitments
                to our clients. To frequently improve the technical skills of
                the team by providing proper support and training.
              </p>
            </div>
          </div>
          <div className="pdtbox1">
            <div className="pdtinbox1">
              <p className="pdthead1">Our Goal</p>
              <p className="pdtcnt1">
                Our aim is to become one of the top engineering solution
                provider & servicing company in the market.
              </p>
            </div>
            <div data-aos="fade-right" className="imgpdt1">
              <div className="pdt-img1">
                <div className="pdtImg1" style={pdtimg3Style}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* We Are Professional At Making */}
      <div className="profmak">
        <div className="profbox1">
          <div>
            <img className="profimg1" src={profmak1} alt="profimg1" />
          </div>
          <div>
            <img className="profimg2" src={profmak2} alt="profimg2" />
          </div>
        </div>
        <div className="profbox2">
          <div>
            <p className="profhead">We Are Professional At Making</p>
          </div>
          <div className="profinbox1">
            <div className="profimg">
              <img className="profimg3" src={profmak3} alt="profimg3" />
            </div>
            <div className="profcnt">
              <p className="profcnt1">Steel Structure</p>
              <p className="profcnt1">Solar Supporting System</p>
              <p className="profcnt1">Oil & Gas Equipment Fabrication</p>
              <p className="profcnt1">Interior Fabrication</p>
              <p className="profcnt1">Vehicle Modification...</p>
            </div>
          </div>
        </div>
      </div>
      {/* Contact with us */}
      <Contact />
    </div>
  );
}
